import React, {useEffect} from "react";
import { useAuth0 } from "@auth0/auth0-react";
import {Route, Router, Switch, useHistory, useLocation} from "react-router-dom";
import history from "./history";
import HomeAuth0 from "./HomeAuth0";
import Callback from "../auth/auth0/Callback";
import LinearProgress from "@mui/material/LinearProgress";
import {getTheme} from "./helper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

export function AppAuth0(props) {

    const { loginWithRedirect, logout, user, isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
    console.log ('AppAuth0 - isAuthenticated=', isAuthenticated, 'user=', user)

    const theme = getTheme()

    console.log ('theme = ', theme)

    const secondaryColour =  theme?.palette?.secondary?.main || "#808080"

    console.log ('secondaryColour=', secondaryColour)

    const params = new URLSearchParams(window.location.search);

    // Check for Auth0 error parameters in the URL
    const error = params.get('error');
    const errorDescription = params.get("error_description");

    const retryLogin = () => {
        window.open(window.location.origin, "_self");
    }

    // Redirect to Auth0 Universal Login if not authenticated
    useEffect(() => {

        // If we're loading Auth0 state, wait
        if (isLoading) return;

        // If Auth0 returned an error, stop here to prevent loops
        if (error) {
            console.error("Auth0 login error:", error, errorDescription);
            return;
        }

        const trySilentLogin = async () => {
            try {
                await getAccessTokenSilently();
                console.log("Silent login successful");
            } catch (err) {
                console.log("Silent login failed, redirecting to login...");
                await loginWithRedirect();
            }
        };

        // If not authenticated, go to Auth0 login
        if (!isAuthenticated) {
            trySilentLogin();
        }


    }, [isLoading, isAuthenticated, loginWithRedirect]);

    if (error) {
        return (
            <React.Fragment>
                <div style={{textAlign: "center", borderColor: '#ddd #ddd #d8d8d8', boxShadow: 'box-shadow: 0 2px 0 hsla(0,0%,68.6%,.12', width: "50%", height: "50%", overflow: 'visible', margin: 'auto', position: 'absolute', top: '0', left: '0', bottom: '0', right: '0'}}>
                    <img src={window.location.origin + '/images/authlogo.png'} alt="logo"
                         style={{display: "block", margin: "0 auto", maxWidth: "200px", maxHeight: "40px"}}/><br/><br/>
                    <Typography variant="h6">{window.REACT_APP_APP_TITLE}</Typography><br/><br/>
                    <Typography variant="subtitle1">An error has occurred, please retry.</Typography><br/><br/>
                    <Typography variant="subtitle1" style={{color: '#808080'}}>Login failed: {errorDescription}</Typography><br/><br/>

                    <Button variant="contained" onClick={retryLogin} style={{width: "200px", marginTop: "20px", backgroundColor: secondaryColour}}>Retry</Button>
                </div>
            </React.Fragment>
        );
    } else if (isLoading) {
        return (
            <React.Fragment>
                <LinearProgress sx={{
                    backgroundColor: "#e0e0e0", // track color
                    "& .MuiLinearProgress-bar": {backgroundColor: secondaryColour} // bar color
                }}/>
            </React.Fragment>
        );
    }

    return (
        <>
            {!isAuthenticated ? (
                <React.Fragment>
                    <LinearProgress sx={{
                        backgroundColor: "#e0e0e0", // track color
                        "& .MuiLinearProgress-bar": {backgroundColor: secondaryColour} // bar color
                    }}/>
                </React.Fragment>
            ) : (

                <div>
                    <React.Fragment>
                        <Router history={history}>
                            <Switch>
                                {/*if case token required will route to callback after login to get code and then call security api with this to get case token*/}
                                <Route path="/callback" component={Callback} />

                                {/*otherwise just route to Home*/}
                                <Route exact path="/" render={props => <HomeAuth0 {...props}  user={user} logout={logout}  launchDashboard={false} />} />
                                <Route exact path="/debug" render={props => <HomeAuth0 {...props}   user={user} logout={logout}  launchDashboard={false} />} />
                                <Route exact path="/dashboard" render={props => <HomeAuth0 {...props}   user={user} logout={logout}   launchDashboard={true} />} />
                                <Route exact path="/file/:id" render={props => <HomeAuth0 {...props}  user={user} logout={logout}    launchDashboard={false} />} />
                                <Route exact path="/upload/:workspace" render={props => <HomeAuth0 {...props}  user={user} logout={logout}  launchDashboard={false} />} />
                                <Route exact path="/folder/:folderId" render={props => <HomeAuth0 {...props}   user={user} logout={logout}   launchDashboard={false}/>} />
                                <Route exact path="/search" render={props => <HomeAuth0 {...props}  user={user} logout={logout}  launchDashboard={false}/>} />
                            </Switch>
                        </Router>

                    </React.Fragment>
                </div>
            )}
        </>
    );
}
